import { createStore } from 'satcheljs';
import { WhatsNewStore } from './schema/WhatsNewStore';

export let getStore = createStore<WhatsNewStore>('whatsNewStore', {
    cards: null,
    disablePauseInboxTryIt: false,
});
